module.exports = __webpack_public_path__ + "media/2022/student-news-d349d2fb.png";